var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserManualMaintenanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H32C40.8366 0 48 7.16344 48 16V32C48 40.8366 40.8366 48 32 48H16C7.16344 48 0 40.8366 0 32V16Z",
    fill: "#F0FDF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7 18.3C26.5168 18.4869 26.4141 18.7382 26.4141 19C26.4141 19.2618 26.5168 19.5131 26.7 19.7L28.3 21.3C28.4869 21.4832 28.7382 21.5859 29 21.5859C29.2617 21.5859 29.5131 21.4832 29.7 21.3L32.806 18.195C33.126 17.873 33.669 17.975 33.789 18.413C34.0911 19.5119 34.074 20.6741 33.7398 21.7636C33.4055 22.8531 32.7678 23.8249 31.9014 24.5652C31.0349 25.3056 29.9756 25.7838 28.8472 25.9441C27.7189 26.1043 26.5683 25.9399 25.53 25.47L17.62 33.38C17.2222 33.7777 16.6826 34.0011 16.1201 34.001C15.5576 34.0009 15.0182 33.7773 14.6205 33.3795C14.2228 32.9817 13.9994 32.4422 13.9995 31.8796C13.9996 31.3171 14.2232 30.7777 14.621 30.38L22.531 22.47C22.0611 21.4317 21.8967 20.2811 22.0569 19.1527C22.2171 18.0244 22.6954 16.965 23.4357 16.0986C24.1761 15.2322 25.1479 14.5945 26.2374 14.2602C27.3269 13.9259 28.4891 13.9089 29.588 14.211C30.026 14.331 30.128 14.873 29.807 15.195L26.7 18.3Z",
    stroke: "#00A63E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManualMaintenanceIcon);
export default __webpack_public_path__ + "static/media/user_manual_maintenance_icon.a8aeb5944e41f2b90b9599bbbb52ef9c.svg";
export { ForwardRef as ReactComponent };